import PropTypes from "prop-types";
import React, { Component } from "react";
import AdminPageLayout from "../../../../components/FullPageLayout/AdminPageLayout";
import { Box } from "@mui/material";
import {
  fetchRelatedItem,
  createItemVersion
} from "../../../../redux/actions/repositoryActions";
import { connect } from "react-redux";
import { push } from "connected-react-router";
import { bindActionCreators } from "redux";
import LoadingSpinner from "../../../../components/LoadingSpinner/LoadingSpinner";
import AddNewContentVersionForm from "../../../../components/Repository/AddNewContentVersionForm";
import AddRepoItemVersionConfirmationModal from "../../../../components/WarningModal/AddRepoItemVersionConfirmationModal";
import ProcessingModal from "../../../../components/ProcessingModal/ProcessingModal";
import { withTranslation } from "react-i18next";
import { buildManageRepositoryItemRoute } from "../../../../routes/AdminRoutes";
import { makeGetEntities } from "../../../../redux/selectors/selectors";
import { ActionCableConsumer } from "react-actioncable-provider";
import {
  enqueueErrorSnackbar,
  enqueueSuccessSnackbar
} from "../../../../redux/actions/snackbarActions";
import { getCourseNames } from "../../../../utils/course_utils";
import { showJobWarnings } from "../../../../utils/repositoryUtils";

class AddRepositoryItemVersion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      confirmationOpen: false,
      isSubmitting: false,
      dataToSubmit: {},
      runningJobId: null,
      repositoryId: null,
      repositoryItemVersionId: null
    };
  }

  activeAssociatedCourses = () => {
    const { repositoryItem } = this.props;
    return repositoryItem && repositoryItem.associatedCourses
      ? repositoryItem.associatedCourses.filter(course => course.isActive)
      : [];
  };

  handleCloseIconClick = () => {
    const {
      match: {
        params: { repositoryId, itemId }
      },
      push
    } = this.props;
    push(buildManageRepositoryItemRoute(repositoryId, itemId));
  };

  showConfirmation = data => {
    this.setState({ confirmationOpen: true, dataToSubmit: data });
  };

  hideConfirmation = data => {
    this.setState({
      confirmationOpen: false,
      dataToSubmit: {},
      isSubmitting: false
    });
  };

  setSubmitting = val => {
    this.setState({ isSubmitting: val });
  };

  showSuccessMessage = () => {
    const { t, enqueueSuccessSnackbar } = this.props;
    enqueueSuccessSnackbar({
      message: t("manageRepository.addItemVersionSuccess")
    });
  };

  /**
   * Submit the new repository item version
   */
  handleSubmit = data => {
    const {
      match: {
        params: { repositoryId, itemId }
      },
      push,
      repositoryItem,
      user
    } = this.props;

    const formData =
      this.activeAssociatedCourses().length === 0
        ? data
        : this.state.dataToSubmit;

    const newItemData = {
      ...formData,
      sharedId: repositoryItem.sharedId,
      creatorId: user.id
    };

    this.setSubmitting(true);

    return this.props.createItemVersion(
      itemId,
      newItemData,
      response => {
        if (response.data.attributes.jobId) {
          this.setState({ runningJobId: response.data.attributes.jobId });
          this.setState({ repositoryId: repositoryId });
          this.setState({ repositoryItemVersionId: response.data.id });
        } else {
          this.setSubmitting(false);
          this.showSuccessMessage();
          push(buildManageRepositoryItemRoute(repositoryId, response.data.id));
        }
      },
      error => {
        this.hideConfirmation();
        console.error(error);
      }
    );
  };

  componentDidMount() {
    const {
      fetchRelatedItem,
      match: {
        params: { repositoryId, itemId }
      }
    } = this.props;
    fetchRelatedItem(repositoryId, itemId, {
      include: "versions,repository,associated_items,associated_courses"
    });
  }

  render() {
    const { t, repositoryItem, push } = this.props;
    const { isSubmitting } = this.state;

    const associatedCourses = this.activeAssociatedCourses();
    const courseNames = getCourseNames(associatedCourses);

    const isUploading = () => {
      return (
        (["file", "video"].includes(repositoryItem.itemType) ||
          (repositoryItem.itemType === "extended" &&
            repositoryItem.extendedItemType === "scorm")) &&
        isSubmitting
      );
    };

    return repositoryItem ? (
      <AdminPageLayout
        title={t("manageRepository.addItemVersionTitle", {
          itemName: repositoryItem.name
        })}
        onCloseIconClick={this.handleCloseIconClick}
      >
        <Box mt={4}>
          <AddRepoItemVersionConfirmationModal
            courseNames={courseNames}
            open={this.state.confirmationOpen}
            onSubmit={this.handleSubmit}
            onClose={this.hideConfirmation}
          />
          <ProcessingModal
            open={isUploading()}
            messageText={t("addNewContent.uploadProcessingMessage")}
          />
          <AddNewContentVersionForm
            defaultData={repositoryItem}
            isSubmitting={isSubmitting}
            onSubmit={
              associatedCourses.length > 0
                ? this.showConfirmation
                : this.handleSubmit
            }
          />
          {!!this.state.runningJobId && (
            <ActionCableConsumer
              channel={{
                channel: "ScormProgressChannel",
                job_id: this.state.runningJobId
              }}
              onReceived={response => {
                console.log("response from ScormProgressChannel", response);
                showJobWarnings(response);
                this.setSubmitting(false);
                this.setState({ runningJobId: null });
                if (response.result) {
                  this.showSuccessMessage();
                  push(
                    buildManageRepositoryItemRoute(
                      this.state.repositoryId,
                      this.state.repositoryItemVersionId
                    )
                  );
                } else {
                  this.hideConfirmation();
                  console.error("File upload to Scorm Engine failed");
                  this.props.enqueueErrorSnackbar({
                    message: t(
                      "manageRepository.downloadTooltip." + response.title
                    )
                  });
                }
              }}
            />
          )}
        </Box>
      </AdminPageLayout>
    ) : this.props.loading ? (
      <LoadingSpinner />
    ) : null;
  }
}

const makeMapStateToProps = () => {
  const mapStateToProps = (state, props) => {
    const selector = makeGetEntities();
    const repositoryItem = selector(state.repositoryState, {
      type: "items",
      id: props.match.params.itemId
    });
    const user = state.userState.user;
    return {
      repositoryItem,
      user
    };
  };
  return mapStateToProps;
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      fetchRelatedItem,
      createItemVersion,
      enqueueErrorSnackbar,
      enqueueSuccessSnackbar,
      push
    },
    dispatch
  );
}
const TranslatedAddRepositoryItemVersion = withTranslation()(
  AddRepositoryItemVersion
);

export default connect(
  makeMapStateToProps,
  mapDispatchToProps
)(TranslatedAddRepositoryItemVersion);

AddRepositoryItemVersion.propTypes = {
  /**
   * Called to fetch the repository data
   */
  fetchRelatedItem: PropTypes.func,
  loading: PropTypes.bool,
  location: PropTypes.object,
  /**
   * The ID for the newly added repository item. Used to direct the user
   * to the manage repository item page for the item.
   */
  push: PropTypes.func,
  /**
   * THe data for the previous item's version
   */
  repositoryItem: PropTypes.object,
  /**
   * Called when the user presses the submit button to create the new repository item
   */
  createItemVersion: PropTypes.func
};
